export default __webpack_public_path__ + "static/media/tags.e90a07cf.svg";